module.exports = __webpack_public_path__ + "link.svg?326f34168e4c98a166f109d491ca5454";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/link.svg
// module id = 36
// module chunks = 0